import { render } from "./usePrdExpired.vue?vue&type=template&id=7188dcad"
import script from "./usePrdExpired.vue?vue&type=script&lang=js"
export * from "./usePrdExpired.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__